/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AppRouteImport } from './routes/_app';
import { Route as CrewRouteImport } from './routes/crew';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AppIndexRouteImport } from './routes/_app/index';
import { Route as AppAlertsRouteImport } from './routes/_app/alerts';
import { Route as AppAssumptionsRouteImport } from './routes/_app/assumptions';
import { Route as AppBarnOpsRouteImport } from './routes/_app/barn-ops';
import { Route as AppBarnScheduleRouteImport } from './routes/_app/barn-schedule';
import { Route as AppCashFlowRouteImport } from './routes/_app/cash-flow';
import { Route as AppFlockCostsRouteImport } from './routes/_app/flock-costs';
import { Route as AppInventoryRouteImport } from './routes/_app/inventory';
import { Route as AppPricingRouteImport } from './routes/_app/pricing';
import { Route as AppProductionRouteImport } from './routes/_app/production';
import { Route as AppRevenueRouteImport } from './routes/_app/revenue';
import { Route as AppSalesForecastRouteImport } from './routes/_app/sales-forecast';
import { Route as AppSystemRouteImport } from './routes/_app/system';
import { Route as AppWeatherRouteImport } from './routes/_app/weather';

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const CrewRoute = CrewRouteImport.update({
  id: '/crew',
  path: '/crew',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any);
const AppAssumptionsRoute = AppAssumptionsRouteImport.update({
  id: '/assumptions',
  path: '/assumptions',
  getParentRoute: () => AppRoute,
} as any);
const AppBarnOpsRoute = AppBarnOpsRouteImport.update({
  id: '/barn-ops',
  path: '/barn-ops',
  getParentRoute: () => AppRoute,
} as any);
const AppBarnScheduleRoute = AppBarnScheduleRouteImport.update({
  id: '/barn-schedule',
  path: '/barn-schedule',
  getParentRoute: () => AppRoute,
} as any);
const AppCashFlowRoute = AppCashFlowRouteImport.update({
  id: '/cash-flow',
  path: '/cash-flow',
  getParentRoute: () => AppRoute,
} as any);
const AppFlockCostsRoute = AppFlockCostsRouteImport.update({
  id: '/flock-costs',
  path: '/flock-costs',
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any);
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRoute,
} as any);
const AppProductionRoute = AppProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => AppRoute,
} as any);
const AppRevenueRoute = AppRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AppRoute,
} as any);
const AppSalesForecastRoute = AppSalesForecastRouteImport.update({
  id: '/sales-forecast',
  path: '/sales-forecast',
  getParentRoute: () => AppRoute,
} as any);
const AppSystemRoute = AppSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRoute,
} as any);
const AppWeatherRoute = AppWeatherRouteImport.update({
  id: '/weather',
  path: '/weather',
  getParentRoute: () => AppRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute;
  '/crew': typeof CrewRoute;
  '/login': typeof LoginRoute;
  '/alerts': typeof AppAlertsRoute;
  '/assumptions': typeof AppAssumptionsRoute;
  '/barn-ops': typeof AppBarnOpsRoute;
  '/barn-schedule': typeof AppBarnScheduleRoute;
  '/cash-flow': typeof AppCashFlowRoute;
  '/flock-costs': typeof AppFlockCostsRoute;
  '/inventory': typeof AppInventoryRoute;
  '/pricing': typeof AppPricingRoute;
  '/production': typeof AppProductionRoute;
  '/revenue': typeof AppRevenueRoute;
  '/sales-forecast': typeof AppSalesForecastRoute;
  '/system': typeof AppSystemRoute;
  '/weather': typeof AppWeatherRoute;
}
export interface FileRoutesByTo {
  '/crew': typeof CrewRoute;
  '/login': typeof LoginRoute;
  '/alerts': typeof AppAlertsRoute;
  '/assumptions': typeof AppAssumptionsRoute;
  '/barn-ops': typeof AppBarnOpsRoute;
  '/barn-schedule': typeof AppBarnScheduleRoute;
  '/cash-flow': typeof AppCashFlowRoute;
  '/flock-costs': typeof AppFlockCostsRoute;
  '/inventory': typeof AppInventoryRoute;
  '/pricing': typeof AppPricingRoute;
  '/production': typeof AppProductionRoute;
  '/revenue': typeof AppRevenueRoute;
  '/sales-forecast': typeof AppSalesForecastRoute;
  '/system': typeof AppSystemRoute;
  '/weather': typeof AppWeatherRoute;
  '/': typeof AppIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_app': typeof AppRouteWithChildren;
  '/crew': typeof CrewRoute;
  '/login': typeof LoginRoute;
  '/_app/alerts': typeof AppAlertsRoute;
  '/_app/assumptions': typeof AppAssumptionsRoute;
  '/_app/barn-ops': typeof AppBarnOpsRoute;
  '/_app/barn-schedule': typeof AppBarnScheduleRoute;
  '/_app/cash-flow': typeof AppCashFlowRoute;
  '/_app/flock-costs': typeof AppFlockCostsRoute;
  '/_app/inventory': typeof AppInventoryRoute;
  '/_app/pricing': typeof AppPricingRoute;
  '/_app/production': typeof AppProductionRoute;
  '/_app/revenue': typeof AppRevenueRoute;
  '/_app/sales-forecast': typeof AppSalesForecastRoute;
  '/_app/system': typeof AppSystemRoute;
  '/_app/weather': typeof AppWeatherRoute;
  '/_app/': typeof AppIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/crew'
    | '/login'
    | '/alerts'
    | '/assumptions'
    | '/barn-ops'
    | '/barn-schedule'
    | '/cash-flow'
    | '/flock-costs'
    | '/inventory'
    | '/pricing'
    | '/production'
    | '/revenue'
    | '/sales-forecast'
    | '/system'
    | '/weather';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/crew'
    | '/login'
    | '/alerts'
    | '/assumptions'
    | '/barn-ops'
    | '/barn-schedule'
    | '/cash-flow'
    | '/flock-costs'
    | '/inventory'
    | '/pricing'
    | '/production'
    | '/revenue'
    | '/sales-forecast'
    | '/system'
    | '/weather'
    | '/';
  id:
    | '__root__'
    | '/_app'
    | '/crew'
    | '/login'
    | '/_app/alerts'
    | '/_app/assumptions'
    | '/_app/barn-ops'
    | '/_app/barn-schedule'
    | '/_app/cash-flow'
    | '/_app/flock-costs'
    | '/_app/inventory'
    | '/_app/pricing'
    | '/_app/production'
    | '/_app/revenue'
    | '/_app/sales-forecast'
    | '/_app/system'
    | '/_app/weather'
    | '/_app/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  CrewRoute: typeof CrewRoute;
  LoginRoute: typeof LoginRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/crew': {
      id: '/crew';
      path: '/crew';
      fullPath: '/crew';
      preLoaderRoute: typeof CrewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/': {
      id: '/_app/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/alerts': {
      id: '/_app/alerts';
      path: '/alerts';
      fullPath: '/alerts';
      preLoaderRoute: typeof AppAlertsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/assumptions': {
      id: '/_app/assumptions';
      path: '/assumptions';
      fullPath: '/assumptions';
      preLoaderRoute: typeof AppAssumptionsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/barn-ops': {
      id: '/_app/barn-ops';
      path: '/barn-ops';
      fullPath: '/barn-ops';
      preLoaderRoute: typeof AppBarnOpsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/barn-schedule': {
      id: '/_app/barn-schedule';
      path: '/barn-schedule';
      fullPath: '/barn-schedule';
      preLoaderRoute: typeof AppBarnScheduleRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/cash-flow': {
      id: '/_app/cash-flow';
      path: '/cash-flow';
      fullPath: '/cash-flow';
      preLoaderRoute: typeof AppCashFlowRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/flock-costs': {
      id: '/_app/flock-costs';
      path: '/flock-costs';
      fullPath: '/flock-costs';
      preLoaderRoute: typeof AppFlockCostsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/inventory': {
      id: '/_app/inventory';
      path: '/inventory';
      fullPath: '/inventory';
      preLoaderRoute: typeof AppInventoryRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pricing': {
      id: '/_app/pricing';
      path: '/pricing';
      fullPath: '/pricing';
      preLoaderRoute: typeof AppPricingRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/production': {
      id: '/_app/production';
      path: '/production';
      fullPath: '/production';
      preLoaderRoute: typeof AppProductionRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/revenue': {
      id: '/_app/revenue';
      path: '/revenue';
      fullPath: '/revenue';
      preLoaderRoute: typeof AppRevenueRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/sales-forecast': {
      id: '/_app/sales-forecast';
      path: '/sales-forecast';
      fullPath: '/sales-forecast';
      preLoaderRoute: typeof AppSalesForecastRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/system': {
      id: '/_app/system';
      path: '/system';
      fullPath: '/system';
      preLoaderRoute: typeof AppSystemRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/weather': {
      id: '/_app/weather';
      path: '/weather';
      fullPath: '/weather';
      preLoaderRoute: typeof AppWeatherRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppAlertsRoute: typeof AppAlertsRoute;
  AppAssumptionsRoute: typeof AppAssumptionsRoute;
  AppBarnOpsRoute: typeof AppBarnOpsRoute;
  AppBarnScheduleRoute: typeof AppBarnScheduleRoute;
  AppCashFlowRoute: typeof AppCashFlowRoute;
  AppFlockCostsRoute: typeof AppFlockCostsRoute;
  AppInventoryRoute: typeof AppInventoryRoute;
  AppPricingRoute: typeof AppPricingRoute;
  AppProductionRoute: typeof AppProductionRoute;
  AppRevenueRoute: typeof AppRevenueRoute;
  AppSalesForecastRoute: typeof AppSalesForecastRoute;
  AppSystemRoute: typeof AppSystemRoute;
  AppWeatherRoute: typeof AppWeatherRoute;
  AppIndexRoute: typeof AppIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAlertsRoute: AppAlertsRoute,
  AppAssumptionsRoute: AppAssumptionsRoute,
  AppBarnOpsRoute: AppBarnOpsRoute,
  AppBarnScheduleRoute: AppBarnScheduleRoute,
  AppCashFlowRoute: AppCashFlowRoute,
  AppFlockCostsRoute: AppFlockCostsRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppPricingRoute: AppPricingRoute,
  AppProductionRoute: AppProductionRoute,
  AppRevenueRoute: AppRevenueRoute,
  AppSalesForecastRoute: AppSalesForecastRoute,
  AppSystemRoute: AppSystemRoute,
  AppWeatherRoute: AppWeatherRoute,
  AppIndexRoute: AppIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  CrewRoute: CrewRoute,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
